import React from 'react';

import MaterialIcon from '../../../components/MaterialIcon';

const ClimateNavigation = ({ activeView, res, onChange }) => (
    <nav className="weather-main-tabs" aria-label={res.CLIMA}>
        {[
            ['overview', 'home', res.VISAO_GERAL],
            ['history', 'show_chart', res.HISTORICO],
            ['forecast', 'wb_cloudy', res.PREVISAO_TEMPO],
            ['stations', 'map', `${res.ESTACAO} / ${res.MAPA}`]
        ].map(([key, icon, label]) => (
            <button type="button" key={key} className={`weather-main-tab ${activeView === key ? 'is-active' : ''}`} onClick={() => onChange(key)}>
                <MaterialIcon icon={icon} />{label}
            </button>
        ))}
    </nav>
);

export default ClimateNavigation;
